import { render, staticRenderFns } from "./userTemplatesTableInEntityProfiles.vue?vue&type=template&id=572374e3&scoped=true"
import script from "./userTemplatesTableInEntityProfiles.vue?vue&type=script&lang=js"
export * from "./userTemplatesTableInEntityProfiles.vue?vue&type=script&lang=js"
import style0 from "./userTemplatesTableInEntityProfiles.vue?vue&type=style&index=0&id=572374e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572374e3",
  null
  
)

export default component.exports